import * as requestFromServer from './ordersCrud';
import { ordersSlice, callTypes } from './ordersSlice';

const { actions } = ordersSlice;

export const fetchOrders = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findOrders(queryParams)
    .then((response) => {
      //console.log('ordersAction: fetchOrders ...');
      //console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          const { totalCount, entities } = {
            totalCount: response.data.data.totalCount,
            entities: response.data.data.list,
          };
          dispatch(actions.ordersFetched({ totalCount, entities }));
          break;
        default:
          var error = response.data.msg.desc;
          dispatch(actions.catchError({ error, callType: callTypes.list }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find orders";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchOrder = (orderCode) => (dispatch) => {
  if (!orderCode) {
    return dispatch(actions.orderFetched({ orderForView: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getOrder(orderCode)
    .then((response) => {
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.orderFetched({ orderForView: response.data.data }));
          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find order";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createOrder = (order) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createOrder(order)
    .then((response) => {
      console.log(response.data);
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.orderFetched({ orderForView: response.data.data }));
          dispatch(
            actions.sendMsg({
              msg: 'Амжилттай хадгаллаа!',
              callType: callTypes.action,
            })
          );
          break;
        default:
          var error = response.data.msg.desc;
          //console.log('createOrder err', error);
          dispatch(actions.catchError({ error, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't create order";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateOrder = (orderForView) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateOrder(orderForView)
    .then((response) => {
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.orderUpdated({ orderForView: response.data.data }));
          dispatch(
            actions.sendMsg({
              msg: 'Амжилттай хадгаллаа!',
              callType: callTypes.action,
            })
          );
          break;
        default:
          var error = response.data.msg.desc;
          dispatch(actions.catchError({ error, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't update order";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteOrder = (orderCode) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteOrder(orderCode)
    .then((response) => {
      switch (response.data.type) {
        case 'SUCCESS':
        case 'SUCCESS_WITH_WARNING':
        case 'SUCCESS_WITH_INFO':
          dispatch(actions.orderDeleted({ orderCode }));

          break;
        default:
          var err = response.data.msg;
          dispatch(actions.catchError({ err, callType: callTypes.action }));
          break;
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't close order";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const clearOrder = () => (dispatch) => {
  dispatch(actions.orderCleared());
};
